import { render, staticRenderFns } from "./FancyCircleWithImageDescription.vue?vue&type=template&id=448a2735&scoped=true"
import script from "./FancyCircleWithImageDescription.vue?vue&type=script&lang=js"
export * from "./FancyCircleWithImageDescription.vue?vue&type=script&lang=js"
import style0 from "./FancyCircleWithImageDescription.vue?vue&type=style&index=0&id=448a2735&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448a2735",
  null
  
)

export default component.exports